import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconCancel = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#5f6567"} className={`clock ${props.className}`} viewBox="2.5 2.5 25 25">
        <path d="M15,2.5 C8.0875,2.5 2.5,8.0875 2.5,15 C2.5,21.9125 8.0875,27.5 15,27.5 C21.9125,27.5 27.5,21.9125 27.5,15 C27.5,8.0875 21.9125,2.5 15,2.5 Z M15,25 C9.4875,25 5,20.5125 5,15 C5,9.4875 9.4875,5 15,5 C20.5125,5 25,9.4875 25,15 C25,20.5125 20.5125,25 15,25 Z M19.4875,8.75 L15,13.2375 L10.5125,8.75 L8.75,10.5125 L13.2375,15 L8.75,19.4875 L10.5125,21.25 L15,16.7625 L19.4875,21.25 L21.25,19.4875 L16.7625,15 L21.25,10.5125 L19.4875,8.75 Z"></path>
    </IconWrapper>
);

export default memo(IconCancel);
